'use client'

import { DataList } from '@morpho-org/ui-v6/client'
import { Skeleton } from '@morpho-org/ui-v6/server'
import { memo } from 'react'

import InfoMarketDataListLayout from '../InfoMarketDataListLayout'

const InfoMarketDataListLoading = () => {
  return (
    <InfoMarketDataListLayout>
      <DataList.Root fullWidth>
        <DataList.Column>
          <InfoDataLineLoading />
          <InfoDataLineLoading />
          <InfoDataLineLoading />
        </DataList.Column>

        <DataList.Column>
          <InfoDataLineLoading />
          <InfoDataLineLoading />
          <InfoDataLineLoading />
          <InfoDataLineLoading />
        </DataList.Column>
      </DataList.Root>
    </InfoMarketDataListLayout>
  )
}

const InfoDataLineLoading = () => (
  <DataList.Line>
    <Skeleton className="h-md w-[100%] rounded-[20px]" />
  </DataList.Line>
)

export default memo(InfoMarketDataListLoading)
